import type { ComponentProps } from "react"
import { CommandInputUnstyled as CommandInputBase } from "@/v2-ui/command/base/CommandBase"
import cn from "@/v2-ui/utils/utils.cn"

export type CommandInputUnstyledProps = ComponentProps<typeof CommandInputBase>

function CommandInputUnstyled(props: CommandInputUnstyledProps) {
  const { className, ...commandInputBaseProps } = props
  return (
    <CommandInputBase
      className={cn("ui-command-input-unstyled", className)}
      {...commandInputBaseProps}
    />
  )
}

export default CommandInputUnstyled
